// extracted by mini-css-extract-plugin
export default {"description":"Mainpage_description__snOBb"};